import { Stack } from "@mui/material";
import type { FC } from "react";
import { usePortfolioDocumentsQuery } from "web_myplann/Api/Portfolio/usePortfolioDocumentsQuery";
import type { ClientPropertyArtDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { RelatedSection } from "web_myplann/Portfolio/Components/RelatedSection";
import {
	DataCard,
	DataCardPreset,
} from "web_myplann/Shared/Components/DataCard";
import { DataNote } from "web_myplann/Shared/Components/DataNote";
import { DataRow } from "web_myplann/Shared/Components/DataRow";
import {
	dateFormatter,
	moneyFormatter,
} from "web_myplann/Shared/Utils/formatters";

const PageResources = Resources.PortfolioDetail;

type Props = {
	data: ClientPropertyArtDetailResponseDTO;
	currencySign: string;
	documentsId: number;
};

export const Art: FC<Props> = ({ data, currencySign, documentsId }) => {
	const { t } = useResource();

	const { data: documents } = usePortfolioDocumentsQuery(documentsId);

	const bottomComponent =
		data.purchaseDate || data.description ? (
			<Stack>
				<DataRow
					label={t(PageResources.Property.PurchaseDate)}
					value={dateFormatter(data.purchaseDate)}
				/>
				<DataNote
					label={t(PageResources.Property.AdditionalDescription)}
					text={data.description ?? ""}
				/>
			</Stack>
		) : null;

	return (
		<Stack>
			<DataCard
				preset={DataCardPreset.BasicInfo}
				bottomComponent={bottomComponent}
			>
				<Stack>
					<DataRow
						label={t(PageResources.Property.ItemTitle)}
						value={data.propertyType}
					/>
					<DataNote
						label={t(PageResources.Property.Description)}
						text={data.customDisposition ?? ""}
					/>
				</Stack>
			</DataCard>

			<DataCard preset={DataCardPreset.Value}>
				<Stack>
					<DataRow
						label={t(PageResources.Property.Value)}
						value={moneyFormatter(data.value, currencySign)}
					/>
				</Stack>
			</DataCard>

			<RelatedSection
				documents={documents?.data}
				related={data.related}
				portfolioId={data.id}
			/>
		</Stack>
	);
};
